<template>
  <div class="menu__group">
    <div class="menu__group__main" :class="{
      open: open,
      active: group.path && group.path === path,
      childActive: group.children && group.children.some(child => child.path === path)
    }" @click="handleClick()">
      <span class="menu__group__icon" v-html="group.icon" />
      <div class="menu__title">{{ group.name }}</div>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"
        v-if="!group.path && group.children && group.children.length" class="menu__group__chevron">
        <path
          d="M4.9907 5.96987C4.90238 5.97194 4.81529 5.94898 4.73947 5.90366C4.66365 5.85832 4.6022 5.79247 4.56223 5.71369L0.108269 0.767593C0.0308976 0.674591 -0.00747058 0.555252 0.00120676 0.434587C0.00988411 0.313923 0.0649332 0.201302 0.154815 0.120331C0.244698 0.0393594 0.362434 -0.00367556 0.483346 0.000246332C0.604259 0.00416822 0.718959 0.0547425 0.803406 0.141369L4.9907 4.79234L9.17721 0.141369C9.26171 0.0547425 9.37639 0.00416822 9.49729 0.000246332C9.61819 -0.00367556 9.73595 0.0393594 9.82583 0.120331C9.91572 0.201302 9.97078 0.313923 9.97947 0.434587C9.98808 0.555252 9.94973 0.674591 9.87235 0.767593L5.41842 5.71145C5.37938 5.78835 5.3198 5.85293 5.24627 5.89802C5.17275 5.9431 5.08818 5.96694 5.00194 5.96688L4.9907 5.96987Z"
          fill="currentColor" />
      </svg>
    </div>
    <div class="menu__list" :style="{ height: open ? `${(group.children || []).length * 51 + 15}px` : '0' }">
      <div class="menu__list__wrapper">
        <div class="menu__item" :class="{ active: child.path && child.path === path }"
          v-for="(child, index) in group.children" :key="index" @click="$router.push({ path: child.path })">
          <span class="menu__item__title">{{ child.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
    }
  },
  data: () => ({
    open: false,
  }),
  computed: {
    path() {
      return '/' + this.$route.path.split('/')[1];
    },
  },
  mounted() {
    this.open = (this.group.children || []).some(child => child.path && child.path === this.path)
  },
  methods: {
    handleClick() {
      if (this.group.external) {
        if (this.group.withToken) {
          const t = localStorage.getItem('token');
          const s = localStorage.getItem('sessionId');
          window.open(`${this.group.external}?s=${encodeURIComponent(s)}&t=${encodeURIComponent(t)}`, '_blank');
        } else {
          window.open(this.group.external, '_blank');
        }
        return;
      }
      if (this.group.path) {
        {
          this.$router.push({ path: this.group.path });
        }
      } else if (this.group.children && this.group.children.length) {
        this.open = !this.open;
      }
    },
  }
}
</script>

<style scoped lang="less">
.menu__group__main {
  padding: 11px 20px 11px 34px;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;

  &.open {
    .menu__group__chevron {
      transform: rotate(180deg);
    }
  }

  &:hover .menu__title {
    color: #3190FF;
  }

  &.active {
    color: white;
    background-color: #3190FF;

    .menu__title {
      color: white;
    }
  }

  .menu__group__icon {
    font-size: 0;
    width: 16px;
    height: 16px;
    display: inline-block;
  }

}

.menu__title {
  flex-grow: 1;
}

.menu__list {
  background: white;
  overflow: hidden;
  transition: height 0.2s
}

.menu__list__wrapper {
  padding: 10px 0;
}

.menu__item {
  margin-left: 20px;
  margin-bottom: 5px;
  text-indent: 40px;
  padding: 11px 0;
  width: 160px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: darken(#f3f8ff, 5%);
  }

  &.active {
    color: white;
    background-color: #3190FF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MenuGroup.vue